function get_sesion_local_storage() {
  const local_s = localStorage.getItem('usuario');
  if (local_s === null) {
    return null;
  }

  return JSON.parse(local_s);
}

function borrar_sesion_local_storage() {
  localStorage.removeItem('usuario');
  localStorage.removeItem('ultima_actualizacion_token_fcm');
  window.location.replace(`${base_url}pro/logout`);
}

function guardar_sesion_local_storage(user) {
  localStorage.usuario = JSON.stringify(user);
}

export {
  get_sesion_local_storage,
  borrar_sesion_local_storage,
  guardar_sesion_local_storage,
};
